import axios from "axios";
import { getUrlApi } from "../utils/util";

class AuthenticationService {
    async login(authRequest) {
        var url = `${await getUrlApi()}/v1/auth`;
        return axios.post(`${url}/login`, authRequest);
    }
}

export default new AuthenticationService();
